import { EStatus } from '@unfoldrtech/portal-mic'
import React from 'react'
import { CurrentStatusBadge } from '../../../Global'

export const TableDataCellStatus = ({ dataValue }: { dataValue: EStatus }) => {
  return <CurrentStatusBadge status={dataValue} />
}
